module.exports = __webpack_public_path__ + "img/mongo.3d40302b.png";